import { makeStyles } from "@saleor/macaw-ui";
import React, { FC } from "react";

import DuplicateOrderError from "./DuplicateOrderError";
import OrderBlockCreate from "./OrderBlockCreate";
import OrderProcessing from "./OrderProcessing";
import OrderProcessingFailed from "./OrderProcessingFailed";

export enum OrderProcessStatus {
  success,
  failed,
  inconclusive,
  block,
  timeOut
}

const useStyle = makeStyles(
  () => ({
    container: {
      height: "calc(100vh - 112px)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexDirection: "column"
    },
    root: {
      height: "100%",
      marginBottom: "120px"
    },
    footer: {
      textAlign: "center",
      width: "100%"
    }
  }),
  { name: "ProcessingStyle" }
);
interface OrderProcessingViewProps {
  orderProcessStatus: OrderProcessStatus;
  errorCode?: string;
  code?: string;
  isCreateOrder?: boolean;
  onFailed: () => void;
}

const OrderProcessingView: FC<OrderProcessingViewProps> = ({
  orderProcessStatus,
  errorCode,
  isCreateOrder,
  onFailed,
  code
}) => {
  const styles = useStyle();

  if (orderProcessStatus === OrderProcessStatus.block) {
    return <OrderBlockCreate styles={styles} />;
  }
  if (orderProcessStatus === OrderProcessStatus.success) {
    return <OrderProcessing isCreateOrder={isCreateOrder} styles={styles} />;
  }
  if (orderProcessStatus === OrderProcessStatus.failed) {
    if (code === "DUPLICATE_ORDER") {
      return (
        <DuplicateOrderError
          errorCode={errorCode}
          styles={styles}
          onFailed={onFailed}
        />
      );
    } else {
      return (
        <OrderProcessingFailed
          onFailed={onFailed}
          errorCode={errorCode}
          styles={styles}
        />
      );
    }
  }

  return <></>;
};

export default OrderProcessingView;
